<template>
  <v-app id="inspire">
    <v-container class="py-12">
      <!-- <v-btn
        :to="home_route"
        color="#18739d"
        style="text-transform: unset !important"
        outlined
        absolute
        top
        left
        small
      >
        <v-icon> mdi-format-horizontal-align-left </v-icon>Back to home
      </v-btn> -->
      <v-row justify="center" align="center">
        <v-col xl="6" lg="6" md="12" xs="12" sm="12">
          <img :src="require('@/assets/images/privlogo.png')" alt="logo" />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col xl="6" lg="6" md="12" xs="12" sm="12">
          <span class="text-h4">Contact us for a free 30 day trial </span>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="isSubmitted">
        <v-col sm="12" xs="12" lg="6" md="12" xl="6"
          ><v-alert outlined text type="success"
            >Thank you for reaching out! We will get back to you within the next
            48 hours.
          </v-alert>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="hasError">
        <v-col sm="12" xs="12" lg="6" md="6" xl="6"
          ><v-alert outlined text type="error"
            >The email you entered is already submitted a query in the system!
          </v-alert>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="6"> </v-col>
      </v-row>
      <v-form ref="form" v-model="valid">
        <v-row justify="center">
          <v-col xl="3" lg="3" md="6" xs="6" sm="6">
            <v-text-field
              dense
              background-color="#FAFAFA"
              tabindex="1"
              outlined
              class="rounded-0"
              v-model="firstName"
              :rules="rules"
              label="First Name"
              required
            ></v-text-field>

            <v-text-field
              dense
              background-color="#FAFAFA"
              tabindex="3"
              outlined
              class="rounded-0"
              v-model="email"
              :rules="emailRules"
              label="Work E-mail"
              required
            ></v-text-field>

            <v-text-field
              dense
              background-color="#FAFAFA"
              tabindex="5"
              outlined
              class="rounded-0"
              v-model="company"
              :rules="rules"
              label="Company"
              required
            ></v-text-field>
          </v-col>

          <v-col xl="3" lg="3" md="6" xs="6" sm="6">
            <v-text-field
              dense
              background-color="#FAFAFA"
              tabindex="2"
              outlined
              class="rounded-0"
              v-model="lastName"
              :rules="rules"
              label="Last Name"
              required
            ></v-text-field>

            <v-text-field
              dense
              background-color="#FAFAFA"
              tabindex="4"
              outlined
              class="rounded-0"
              v-model="jobTitle"
              :rules="rules"
              label="Job Title"
              name="jobTitle"
              required
            ></v-text-field>

            <v-select
              dense
              background-color="#FAFAFA"
              tabindex="6"
              outlined
              class="rounded-0 login_button"
              :items="items"
              :rules="rules"
              label="Solution Type"
              v-model="solutionType"
              required
            ></v-select>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col xl="6" lg="6" md="12" xs="12" sm="12">
            <v-textarea
              outlined
              background-color="#FAFAFA"
              dense
              tabindex="7"
              class="rounded-0"
              label="Additional Details"
              v-model="additionalDetails"
              :counter="500"
              maxlength="500"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" class="captcha">
          <v-col xl="6" lg="6" md="12" xs="12" sm="12">
            <iframe
              width="500"
              src="https://new-voice-captcha-module.s3.eu-west-1.amazonaws.com/index.html?session_id=67ed4d7a-41c6-4a46-aafb-b58ccc2c29e4&session_password=6iiYEnPDt.mqE-FIAh6HPIsoA0vB2_"
              allow="microphone"
              frameBorder="0"
              scrolling="no"
            />
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col xl="6" lg="6" md="12" xs="12" sm="12">
            <v-checkbox
              v-model="checkbox"
              label="Yes, I'd like Privately to stay in touch with me by email to provide important information about Privately products and other offers."
              required
            ></v-checkbox
          ></v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="6">
            <v-btn
              style="text-transform: unset !important"
              dark
              x-large
              color="#18739d"
              class="mr-4"
              elevation="0"
              @click="submit"
              :ripple="false"
              :loading="loading"
            >
              Submit
            </v-btn></v-col
          >
        </v-row>
      </v-form>
    </v-container>
    <FooterItem />
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import FooterItem from "@/components/FooterItem.vue";

export default {
  components: { FooterItem },
  data: () => ({
    links: [
      {
        title: "Privacy Policy",
        link: "/static/docs/privacy_policy.pdf",
      },
      {
        title: "Terms and Conditions",
        link: "/static/docs/terms_and_conditions.pdf",
      },
      {
        title: "Contact Us",
        link: "mailto:dev_channel_contact@privately.eu",
        mailto: true,
      },
    ],
    loading: false,
    isSubmitted: false,
    hasError: false,
    valid: false,
    home_route: "/home",
    firstName: "",
    solutionType: "",
    items: ["SDK - Android", "SDK - iOS", "SDK - On Browser"],
    lastName: "",
    email: "",
    company: "",
    jobTitle: "",
    checkbox: false,
    tempEmail: "",
    rules: [(v) => !!v || "This field is required"],
    emailRules: [
      (v) => !!v || "This field is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    select: null,
  }),

  methods: {
    ...mapActions(["ContactUs"]),
    async submit() {
      this.isSubmitted = false;
      this.hasError = false;
      this.validate();
      console.log("submit clicked");
      console.log("valid?", this.valid);
      this.loading = true;
      if (this.valid) {
        this.tempEmail = this.email;
        let payload = {
          email: this.email,
          additional_info_fields: {
            company: this.company,
            name: this.firstName + " " + this.lastName,
            job_title: this.jobTitle,
            subscribe_news: this.checkbox,
            solution_type: this.solutionType,
            additional_details: this.additional_details,
          },
        };
        try {
          console.log("inside try");
          await this.SignUp(payload);
          this.isSubmitted = true;
          this.hasError = false;
          this.loading = false;
          this.reset();
        } catch (err) {
          console.log(err);
          this.loading = false;
          this.hasError = true;
        }
      } else {
        this.loading = false;
      }
    },

    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
  },
};
</script>